import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./errorBanner.html";
class ErrorBanner extends LightningElement {
  constructor(...args) {
    super(...args);
    this.error = void 0;
    this.handleCloseClick = () => {
      const closeEvent = new CustomEvent('close');
      this.dispatchEvent(closeEvent);
    };
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ErrorBanner, {
  publicProps: {
    error: {
      config: 0
    }
  },
  fields: ["handleCloseClick"]
});
const __lwc_component_class_internal = _registerComponent(ErrorBanner, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;